import React, { useEffect, useRef, useState } from "react";
import EditGroup from "../EditGroup";
import { connect, useSelector } from "react-redux";
import { deleteVideoGroup } from "../../store/action";
import { VideoGroupProps } from "../../store/actionType";
import { SmallScreenModel } from "components";
import MenuDropdown from "modules/video/components/MenuDropdown";
import ConfirmationDialogMsg from "modules/video/components/ConfirmationDialogMsg";
import FolderCard from "modules/video/components/FolderCard";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

interface GroupProps {
  groupData: VideoGroupProps;
  onClick: () => void;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & GroupProps;

const GroupCard: React.FC<Props> = ({
  groupData,
  onClick,
  onDeleteVideoGroup,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEidtFormOpen, setIsEidtFormOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const groupsState = useSelector(
    (state: any) => state.videoGroups.videoGroupsState
  );
  const [deleteError, setDeleteError] = useState(null);

  const handleMenuClick = (e: any) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };
  const closeModal = () => {
    setIsEidtFormOpen(false);
  };
  const handleGroupClick = () => {
    if (!isMenuOpen) {
      onClick();
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  const handleDeleteGroup = (e: any) => {
    e.stopPropagation();
    onDeleteVideoGroup(groupData?.id.toString(), groupData?.folder_id);
  };

  const toggleEditModal = () => {
    setIsEidtFormOpen(!isEidtFormOpen);
  };

  const toggleDeleteDialog = () => {
    setIsDeleteDialogOpen(!isDeleteDialogOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    setDeleteError(groupsState.delete);
    if (groupsState.delete === null) {
      setIsDeleteDialogOpen(false);
    }
  }, [groupsState.delete]);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_GROUP));
  return (
    <>
      <FolderCard
        clickedFolder={handleGroupClick}
        clickedMenu={handleMenuClick}
        title={groupData?.name}
        description={""}
        ref={ref}
        orderNumber={groupData?.group_order}
      >
        {isMenuOpen && (
          <>
            {isPermitted ? (
              <MenuDropdown
                clickedDelete={toggleDeleteDialog}
                clickedEdit={toggleEditModal}
                copyId={groupData?.id}
              />
            ) : (
              <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                You don't have the permission.
              </div>
            )}
          </>
        )}
      </FolderCard>
      <SmallScreenModel
        showModal={isEidtFormOpen}
        setShowModal={setIsEidtFormOpen}
      >
        <EditGroup closeModal={closeModal} groupData={groupData} />
      </SmallScreenModel>
      <SmallScreenModel
        showModal={isDeleteDialogOpen}
        setShowModal={setIsDeleteDialogOpen}
      >
        <ConfirmationDialogMsg
          title={"Delete Group"}
          folderName={groupData?.name}
          message={"Are you sure you want to delete?"}
          onConfirm={handleDeleteGroup}
          onCancel={toggleDeleteDialog}
          error={deleteError}
        />
      </SmallScreenModel>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onDeleteVideoGroup: (group_id: string, folder_id: string) =>
    dispatch(deleteVideoGroup(group_id, folder_id)),
});

export default connect(null, mapDispatchToProps)(GroupCard);
